/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../apimodel.d.ts" />
/// <reference path="app.common.directives.module.ts" />
/// <reference path="../services/validationerrormessageresolverservice.ts" />
/// <reference path="validators/mustinclude.ts" />
/// <reference path="validators/mustbebetweendates.ts" />
/// <reference path="validators/mustbeearlierthan.ts" />
/// <reference path="validators/mustbeequalorearlierthan.ts" />
/// <reference path="validators/mustbeequalorlaterthan.ts" />
/// <reference path="validators/mustbelaterthan.ts" />
/// <reference path="validators/mustbesameas.ts" />
/// <reference path="validators/overrideemail.ts" />
/// <reference path="validators/strongpassword.ts" />

((() => {
	'use strict';

	angular
		.module('app.common.directives')
		.run([
			'$injector',
			'$filter',
			'app.common.services.validationErrorMessageResolverService',
			'app.common.services.globalSettingsService', (
				$injector: angular.auto.IInjectorService,
				$filter: angular.IFilterService,
				validationErrorMessageResolverService: App.Common.Services.ValidationErrorMessageResolverService,
				globalSettings: App.Common.Services.GlobalSettingsService) => {

				var validators: App.Common.Directives.IValidator[] = [
					new App.Common.Directives.MustInclude(),
					new App.Common.Directives.MustBeLaterThan($filter, globalSettings),
					new App.Common.Directives.MustBeEarlierThan($filter, globalSettings),
					new App.Common.Directives.MustBeEqualOrLaterThan($filter, globalSettings),
					new App.Common.Directives.MustBeEqualOrEarlierThan($filter, globalSettings),
					new App.Common.Directives.MustBeBetweenDates($filter, globalSettings),
					new App.Common.Directives.OverrideEmail(globalSettings),
					new App.Common.Directives.MustBeSameAs(),
					new App.Common.Directives.StrongPassword(),
					new App.Common.Directives.MustBePostcode(globalSettings)
				];

				validators.forEach((validator: App.Common.Directives.IValidator) => {
					validationErrorMessageResolverService.registerValidator(validator);
				});

			}
		]);

})());